export const DiscountManagementToken = {
  IDiscountManagementRepository: Symbol("IDiscountManagementRepository"),
  DiscountManagementUseCase: Symbol("DiscountManagementUseCase"),
  DiscountManagementViewModel: Symbol("DiscountManagementViewModel"),
};
